import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { forwardRef } from "react";

import {
  type TNavigationMenuIndicatorElement,
  type TNavigationMenuIndicatorProps,
} from "@/ui/components/navigation/NavigationMenu/NavigationMenu.config";
import { cn } from "@/ui/lib/utils";

export const NavigationMenuIndicator = forwardRef<
  TNavigationMenuIndicatorElement,
  TNavigationMenuIndicatorProps
>(({ className, ...props }, ref) => (
  <NavigationMenuPrimitive.Indicator
    ref={ref}
    data-component="NavigationMenuIndicator"
    className={cn(
      "top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
      "data-[state=visible]:animate-in data-[state=hidden]:animate-out",
      "data-[state=hidden]:fade-out data-[state=visible]:fade-in",
      className,
    )}
    {...props}
  >
    <div className="relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sys-xs border border-solid border-component-input-default bg-surface-default shadow-md" />
  </NavigationMenuPrimitive.Indicator>
));

NavigationMenuIndicator.displayName = NavigationMenuPrimitive.Indicator.displayName;
